module.exports = __webpack_public_path__ + "static/img/verticalRotate.98f76d5.svg";